export default "/img/GN.0e4bdde46a55b907c8f6f95cd1847df7.png";